export default __webpack_public_path__ + "b587e3a543842a48c0230f7e4e27dbc0.png";